export default "__VITE_ASSET__CPhfVjVZ__"